import React, { useState, useEffect } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { Table, Checkbox } from 'rsuite'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import { toast } from '../CommonComponents/ToastComponent/toast'
import { getLocationBasedMasterSuppliersForQA, getLocationMasterSuppliersCountForQA } from '../../redux/actions/vendor'
import { Link } from 'react-router-dom'
import { getAbbreviatedState } from '../../services/helper'

const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, dataKey, onClick, ...props }) => {
    let bgColorClass = rowData[dataKey] === 'Approved' ? 'bg-green' : rowData[dataKey] === 'Rejected' ? 'bg-red' : rowData[dataKey] === 'In Calls' ? 'bg-blue' : 'bg-yellow'
    let stateCode = ''
    if (dataKey === 'state') {
        if (rowData?.abbreviatedState === null) {
            stateCode = getAbbreviatedState(rowData?.abbreviatedState, rowData?.state)
        } else {
            stateCode = rowData?.abbreviatedState
        }
    }

    return (
        <Cell {...props} className="table-link">
            {dataKey === 'masterSupplierName' ?
                <Link to={`/suppliers/${rowData.masterId}`} target="_blank">{rowData[dataKey]}</Link>
                :
                dataKey === 'state' ?
                    stateCode
                    :
                    dataKey === 'supplierQARole' ?
                        <h5 style={{ width: '60px' }} className={`btn text-white ${bgColorClass}`}>
                            {rowData[dataKey]}
                        </h5>
                        :
                        <Link to={`/suppliers/relatedsupplier/${rowData.id}`} target="_blank">{rowData[dataKey]}</Link>
            }
        </Cell>
    )
}

const QualityLocationBasedSuppliersComponent = ({ tableData, isLoading = false, onApproveSuppliers, onRejectSuppliers, selectedChildrens, totalLocationMasterRecords, isQANoteSubmitted, updateIsQANoteSubmitted, searchList, searchBoolean }) => {
    const store = useStore().getState()
    const dispatch = useDispatch()
    const {
        app: { childSupplierColumns }
    } = store
    const [checkedKeys, setCheckedKeys] = useState([])
    const [checkedSuppliers, setCheckedSuppliers] = useState([])
    const [showPending, setShowPending] = useState(true)
    const [showApproved, setShowApproved] = useState(false)
    const [showRejected, setShowRejected] = useState(false)
    const [sortColumn, setSortColumn] = useState('id')
    const [sortType, setSortType] = useState('asc')
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [totalTableRecords, setTableTotalRecords] = useState(0)
    const [paginatedData, setPaginatedData] = useState([])

    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
        setCheckedKeys([]);
        setCheckedSuppliers([]);
    }

    const handleChangePage = (event) => {
        setPage(event)
        setCheckedKeys([]);
        setCheckedSuppliers([]);
    }

    useEffect(() => {
        if (!(tableData && tableData?.length > 0)) {
            setPaginatedData([])
            setTableTotalRecords(0)
            return
        }
        setTableTotalRecords(totalLocationMasterRecords)
        setPaginatedData(tableData)
        if (isQANoteSubmitted) {
            setCheckedKeys([])
            setCheckedSuppliers([])
            updateIsQANoteSubmitted()
        }
    }, [tableData])

    const headerElement = childSupplierColumns.map((h, index) => {
        if (index === 0 || index === 1) {
            return (
                <Column
                    resizable
                    sortable
                    key={h.name}
                >
                    <HeaderCell>{h.label}</HeaderCell>
                    <LinkCell dataKey={h.name} />
                </Column>
            )
        }
        return (
            <Column
                resizable
                sortable
                key={h.name}
            >
                <HeaderCell>{h.label}</HeaderCell>
                {h.name === 'state' ?
                    <LinkCell dataKey={h.name} />
                    :
                    <Cell dataKey={h.name} />
                }
            </Column>
        )
    })

    let checked = false
    let indeterminate = false

    if (checkedKeys && tableData && checkedKeys.length === tableData?.length && checkedKeys.length > 0) {
        checked = true;
    } else if (checkedKeys && checkedKeys.length === 0) {
        checked = false;
    } else if (checkedKeys && tableData && checkedKeys.length > 0 && checkedKeys.length < tableData?.length) {
        indeterminate = true;
    }

    const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
        <Cell {...props} style={{ padding: 0 }}>
            <Checkbox
                value={rowData[dataKey]}
                onChange={onChange}
                checked={checkedKeys.some(item => item === rowData[dataKey])}
            />
        </Cell>
    )

    const handleCheckAll = (value, checked) => {
        let keys = checked ? tableData?.map(item => item.id) : []

        if (checked) {
            setCheckedSuppliers(tableData)
        } else {
            setCheckedSuppliers([])
        }
        setCheckedKeys(keys)
    }

    const handleCheck = (value, checked) => {
        const nextCheckedKeys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value)
        setCheckedKeys(nextCheckedKeys)
        let tmpCheckedSuppliers = [...checkedSuppliers];
        if (checked) {
            tmpCheckedSuppliers = [...tmpCheckedSuppliers, tableData?.find(row => row.id === value)]
        } else {
            tmpCheckedSuppliers = tmpCheckedSuppliers.filter(row => row.id !== value)
        }
        setCheckedSuppliers(tmpCheckedSuppliers)
    }

    const handleClickApprove = () => {
        if (!checkedKeys || checkedKeys.length === 0) {
            toast.show({
                title: 'Warning',
                description: 'No supplier selected'
            })
            return
        }
        onApproveSuppliers(checkedKeys, 'locationMaster', limit, page, showPending, showApproved, showRejected)
    }

    const handleClickReject = () => {
        if (!checkedKeys || checkedKeys.length === 0) {
            toast.show({
                title: 'Warning',
                description: 'No supplier selected'
            })
            return
        }
        onRejectSuppliers(checkedKeys, 'locationMaster', limit, page, showPending, showApproved, showRejected)
    }

    const handleSortTableData = (sortColumn, sortType) => {
        setSortColumn(sortColumn)
        setSortType(sortType)
    }

    //---------repair-------------
    let filteredTableData = []
    if (!showPending && !showApproved && !showRejected) {
        filteredTableData = [...tableData]
    } else {
        if (showPending) {
            filteredTableData = [...filteredTableData, ...tableData?.filter(row => row.supplierQARole === 'Pending')]
        }
        if (showApproved) {
            filteredTableData = [...filteredTableData, ...tableData?.filter(row => row.supplierQARole === 'Approved')]
        }
        if (showRejected) {
            filteredTableData = [...filteredTableData, ...tableData?.filter(row => row.supplierQARole === 'Rejected')]
        }
    }

    //--------Master supplier id show----------------
    filteredTableData = [...filteredTableData].map(row => {
        if (row.masterSupplierName === "" || !row.masterSupplierName) {
            if (row.masterId) {
                row.masterSupplierName = row.masterId
            }
        }
        return row
    })
    //----------------------------------------------

    if (selectedChildrens && selectedChildrens.length > 0) {
        const nonSelectedChildrens = filteredTableData?.filter(row => selectedChildrens.findIndex(children => children.id === row.id) === -1)
        filteredTableData = [...selectedChildrens, ...nonSelectedChildrens]
    }
    filteredTableData = filteredTableData?.map(row => ({
        ...row,
        supplierQARole: row?.supplierQARole ? row?.supplierQARole : 'Pending'
    }))

    useEffect(() => {
        if (!(filteredTableData && filteredTableData?.length > 0)) {
            setPaginatedData([])
            return
        }
        const newFilteredData = [...filteredTableData]?.sort((a, b) => {
            let x = a[sortColumn];
            let y = b[sortColumn];
            if (typeof x === 'string') {
                x = x.charCodeAt();
            }
            if (typeof y === 'string') {
                y = y.charCodeAt();
            }
            if (sortType === 'asc') {
                return x - y;
            } else {
                return y - x;
            }
        }).slice(limit * (page - 1), limit * page)

        setPaginatedData(newFilteredData)
    }, [selectedChildrens])

    const setPageData = async (searchList={}) => {
        const data = await dispatch(getLocationBasedMasterSuppliersForQA({
            limit: limit,
            offset: limit * (page - 1),
            pending: showPending,
            approved: showApproved,
            rejected: showRejected,
            searchList
        })).then(res => {
            return res
        })
        return data
    }
    const getTotalSuppliers = async (searchList={}) => {
        dispatch(getLocationMasterSuppliersCountForQA({
            pending: showPending,
            approved: showApproved,
            rejected: showRejected,
            searchList
        })).then(response => {
            setTableTotalRecords(response?.count)
        })
    }

    useEffect(async () => {
        let filteredData = [];
        let tableData;

        if (searchBoolean) {
            tableData = await setPageData(searchList)
            await getTotalSuppliers(searchList)
        } else {
            tableData = await setPageData()
            await getTotalSuppliers()
        }

        if (!showPending && !showApproved && !showRejected) {
            filteredData = [...tableData]
        } else {
            if (showPending) {
                filteredData = [...filteredData, ...tableData?.filter(row => row.supplierQARole === 'Pending')]
            }
            if (showApproved) {
                filteredData = [...filteredData, ...tableData?.filter(row => row.supplierQARole === 'Approved')]
            }
            if (showRejected) {
                filteredData = [...filteredData, ...tableData?.filter(row => row.supplierQARole === 'Rejected')]
            }
        }

        filteredTableData = [...filteredData]?.map(row => ({
            ...row,
            supplierQARole: row?.supplierQARole ? row?.supplierQARole : 'Pending'
        }))

        setPaginatedData(filteredTableData)
    }, [showPending, showApproved, showRejected, page, limit, searchBoolean])

    return (
        <div className="record-container quality-child-record">
            <div className="record-header flex flex-wrap justify-space-between align-center">
                <div className="record-title flex-column flex-md-row">
                    <h1 className='fw-bold'>Location Based Master Suppliers</h1>
                    <div className='d-flex flex-wrap'>
                        <Checkbox
                            checked={showPending}
                            onChange={(value, checked) => { setShowPending(checked); setPage(1); setCheckedKeys([]); setCheckedSuppliers([]); }}
                        >
                            Pending
                        </Checkbox>
                        <Checkbox
                            checked={showApproved}
                            onChange={(value, checked) => { setShowApproved(checked); setPage(1); setCheckedKeys([]); setCheckedSuppliers([]); }}
                        >
                            Approved
                        </Checkbox>
                        <Checkbox
                            checked={showRejected}
                            onChange={(value, checked) => { setShowRejected(checked); setPage(1); setCheckedKeys([]); setCheckedSuppliers([]); }}
                        >
                            Rejected
                        </Checkbox>
                    </div>
                </div>
                <div className="record-toolbar flex flex-wrap align-center">
                    <div className="toolbar-item ps-0 gap-2 flex-wrap">
                        <button className="btn-approve ms-0 h-auto pt-2 pb-2" onClick={handleClickApprove}>Approve</button>
                        <button className="btn-reject ms-0 h-auto pt-2 pb-2" onClick={handleClickReject}>Reject</button>
                    </div>
                </div>
            </div>
            <div className={`record-body ${isLoading ? 'loading' : ''}`}>
                {isLoading && <LoaderComponent />}
                <Table
                    virtualized
                    autoHeight
                    affixHeader={true}
                    data={paginatedData}
                    sortColumn={sortColumn}
                    sortType={sortType}
                    onSortColumn={handleSortTableData}
                >
                    <Column width={50} align="center">
                        <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Checkbox
                                checked={checked}
                                indeterminate={indeterminate}
                                onChange={handleCheckAll}
                            />
                        </HeaderCell>
                        <CheckCell
                            dataKey="id"
                            checkedKeys={checkedKeys}
                            onChange={handleCheck}
                        />
                    </Column>
                    <Column
                        resizable
                        sortable
                        key='supplierQARole'
                    >
                        <HeaderCell>QA Status</HeaderCell>
                        <LinkCell dataKey='supplierQARole' />
                    </Column>
                    {headerElement}
                </Table>
                <div className="pagination">
                    <Pagination
                        prev
                        next
                        first
                        last
                        showInfo
                        maxButtons={5}
                        lengthMenu={[
                            {
                                label: '5',
                                value: 5,
                            },
                            {
                                label: '10',
                                value: 10,
                            },
                            {
                                label: '25',
                                value: 25,
                            },
                            {
                                label: '50',
                                value: 50,
                            },
                        ]}
                        displayLength={limit}
                        total={totalTableRecords}
                        limit={limit}
                        activePage={page}
                        onChangePage={(event) => { handleChangePage(event) }}
                        onChangeLength={handleChangeLimit}
                    />
                </div>
            </div>
        </div>
    )
}

export default QualityLocationBasedSuppliersComponent
